import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Go } from '@ui/legacy-lib';
import { filter, map, tap } from 'rxjs/operators';
import { ThemeService } from '@ui/legacy-lib';
import { FetchSelfRegistrationConfig } from 'landlord/main/+state/offline-self-registration/offline-self-registration.action';
import { offlineSelfRegistrationFeature } from 'landlord/main/+state/offline-self-registration/offline-self-registration.reducers';

@Injectable({
  providedIn: 'root'
})
export class SelfRegistrationGuard {
  private store = inject(Store);
  private themeService = inject(ThemeService);

  canActivate(
    route: ActivatedRouteSnapshot,
    routerStateSnapshot: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (!route.queryParams.token) {
      this.store.dispatch(new Go({ path: ['properties'] }));
      return false;
    } else {
      this.store.dispatch(
        FetchSelfRegistrationConfig({ token: route.queryParams.token })
      );

      return this.store
        .select(offlineSelfRegistrationFeature.selectSelfRegistrationConfig)
        .pipe(
          filter(config => !!config),
          tap(config => {
            if (config.landlordCustomerBranding) {
              this.themeService.createTheme(config.landlordCustomerBranding);
            }
            if (routerStateSnapshot.url.includes('wizard')) {
              this.store.dispatch(
                new Go({
                  path: ['selfRegistration/intro'],
                  extras: { queryParamsHandling: 'preserve' }
                })
              );
            }
          }),
          map(() => true)
        );
    }
  }
}
